/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { InpyVersion } from "./InpyVersion";
import {
  InpyVersionFromJSON,
  InpyVersionFromJSONTyped,
  InpyVersionToJSON,
  InpyVersionToJSONTyped,
} from "./InpyVersion";

/**
 *
 * @export
 * @interface PaginatedInpyVersionList
 */
export interface PaginatedInpyVersionList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<InpyVersion>;
}

/**
 * Check if a given object implements the PaginatedInpyVersionList interface.
 */
export function instanceOfPaginatedInpyVersionList(
  value: object
): value is PaginatedInpyVersionList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedInpyVersionListFromJSON(json: any): PaginatedInpyVersionList {
  return PaginatedInpyVersionListFromJSONTyped(json, false);
}

export function PaginatedInpyVersionListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedInpyVersionList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(InpyVersionFromJSON),
  };
}

export function PaginatedInpyVersionListToJSON(json: any): PaginatedInpyVersionList {
  return PaginatedInpyVersionListToJSONTyped(json, false);
}

export function PaginatedInpyVersionListToJSONTyped(
  value?: PaginatedInpyVersionList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(InpyVersionToJSON),
  };
}
